import { Client } from './client.model';
import { MinimalProvider } from './minimal-provider.model';
import { Office } from './office.model';
import { Patient } from './patient.model';

export class ArsConsultNoteImport {
  id: number;
  uuid: string;
  hrsaId: string;
  documentName: string;
  patientFirst: string;
  patientLast: string;
  patientDob: string;
  providerNpi: string;
  status: string;
  requiresIntervention: boolean;
  exception: string;
  createdAt: string;
  patientAttachmentId: number;
  wipPatientCaptureCount: number;
  wipPatientPrescriberCaptureCount: number;
  client: Client;
  patient: Patient;
  provider: MinimalProvider;
}

export class ArsConsultNoteImportLlmResponse {
  officeName: string;
  officeAddress: string;
  officePhone: string;
  officeFax: string;
}

export class ArsConsultNoteImportDetail extends ArsConsultNoteImport {
  url: string;
  content: string;
  canAssignOffice: boolean;
  canRestartOcr: boolean;
  canRestartLlm: boolean;
  llmResponse: ArsConsultNoteImportLlmResponse;
  office: Office;
}

export class ArsConsultNoteImportFilters {
  requiresIntervention = false;
  patientFirstName: string = null;
  patientLastName: string = null;
  prescriberNpi: string = null;
  selectedClientIds: number[] = [];
}
